<div *ngIf="invalidRouting">
  <mapfre-alert [closeButton]="true" [notTop]="false"></mapfre-alert>
</div>
<mapfre-card 
  [singleCard]="false"
  [additionalClasses]="defaultClasses + ' billing-new-container'">
  <router-outlet></router-outlet>
</mapfre-card>
